<template>
  <div id="fulllist" class="tray full-list" v-bind:class="[{ active: isActive}, options.color]">
    <h1 class="full-list-title">{{options.pageTitle}}</h1>

    <i v-on:click="closeList" class="material-icons tray-icon-close full-list-icon-close">close</i>

    <div class="card" v-bind:class="options.color">
      <h2 class="card-h2" v-bind:class="[{'s-icon': options.titleIcon}]">
        <span>
          <i class="material-icons card-icon" v-if="options.titleIcon">{{options.titleIcon}}</i> 
          {{options.title}}
        </span>
      </h2>
      
      <div class="card-content">
        <BarChart :chart-type="'bar'"
                :chart-data="fullList" 
                :chart-height="75"
                :bar-color="options.barColors" 
                :show-legend="false"
                :label-prefix="options.prefix"></BarChart>
      </div>
    </div>

    <div class="card" v-bind:class="options.color">
      <h2 class="card-h2" v-bind:class="[{'s-icon': options.titleIcon}]">
        <span>
          <i class="material-icons card-icon" v-if="options.titleIcon">{{options.titleIcon}}</i>
          {{options.title}}
        </span>
      </h2>

      <div class="card-content">
        <table class="fetch navigation-board" v-bind:class="[{'is-loading': isLoading}, options.color]">
          <thead v-if="options.ths">
            <tr>
              <th v-for="heading in options.ths">{{heading}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rankItem, index) in fullList" class="full-list-row">
              <td><router-link :to="{name: options.link, params: {id: rankItem.id}}">{{index + 1}}</router-link></td>
              <td><router-link :to="{name: options.link, params: {id: rankItem.id}}">{{rankItem.title}}</router-link></td>
              <td><router-link :to="{name: options.link, params: {id: rankItem.id}}">{{ options.prefix }}{{Number(rankItem.amount).toLocaleString('en-US')}}</router-link></td>
            </tr>
          </tbody>
        </table>
        <div class="loader-dots-wrap center" v-bind:class="[{'is-loading': isLoading}]"><LoaderDots></LoaderDots></div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from '@/components/barCharts/BarChart'
import LoaderDots from '@/components/LoaderDots'
import Moment from 'moment'

export default {
  name: 'fullList',

  props: {
    'getters': {
      type: Object,
      required: true
    }
  },

  mounted: function () {
    if (this.isActive) {
      this.$store.dispatch(this.getters.toggleActive)
    }

    this.$store.dispatch(this.getters.reset)
  },

  components: {
    'BarChart': BarChart,
    'LoaderDots': LoaderDots
  },

  computed: {
    options () {
      return this.$store.getters[this.getters.options]
    },

    filters () {
      let filters = this.$store.getters[this.getters.filters]
      filters.params = this.getters.filterParams

      return filters
    },

    fullList () {
      return this.$store.getters[this.getters.get]
    },

    startDate () {
      return Moment(this.$store.getters[this.getters.filters].startDate).format('MMMM Do YYYY')
    },

    endDate () {
      return Moment(this.$store.getters[this.getters.filters].endDate).format('MMMM Do YYYY')
    },

    isActive () {
      return this.$store.getters[this.getters.active]
    },

    isLoading () {
      return this.fullList.length > 0 ? 0 : 1
    }
  },

  methods: {
    closeList () {
      this.$store.dispatch(this.getters.toggleActive)
      this.$store.dispatch(this.getters.reset)
    }
  },

  watch: {
    isActive: function () {
      if (this.isActive) {
        this.$store.dispatch(this.getters.fetch, {slug: this.options.apiSlug, filters: this.filters})
      }
    }
  }
}
</script>

<style lang="scss">
@import "./src/sass/components/tray.scss";
@import "./src/sass/card.scss";
@import "./src/sass/components/full-list.scss";
</style>



// WEBPACK FOOTER //
// FullList.vue?11edc1de